import React, { useCallback } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation
} from 'react-router-dom';
import qs from 'qs';
import _toLower from 'lodash/toLower';
import styles from './index.module.scss';

import { FreeTrialBanner, StoreConnector, UiKit } from 'components';
import { ROUTES } from './stubs';

function ConnectStore() {
  const { search } = useLocation();
  const { push } = useHistory();

  const { referrer, free_trial: trialPeriod } = qs.parse(search.slice(1));

  const onTileClick = useCallback(
    (ecommPlatform, { search }) => {
      const route = `${ROUTES.ROOT}/${_toLower(ecommPlatform)}${search}`;
      push(route);
    },
    [push]
  );

  const onBackToRoot = useCallback(
    queryParamsObj => {
      const queryParams = qs.stringify(queryParamsObj);
      const backRoute = `${ROUTES.ROOT}${queryParams ? `?${queryParams}` : ''}`;
      push(backRoute);
    },
    [push]
  );

  return (
    <UiKit.Grid templateColumns="1fr" className={styles.container}>
      <FreeTrialBanner
        referrer={referrer}
        trialPeriod={trialPeriod}
        className={styles.banner}
      />
      <div className={styles.content}>
        <Switch>
          <Route exact path={ROUTES.SHOPIFY_CONNECT}>
            <StoreConnector.Form store="SHOPIFY" onCancel={onBackToRoot} />
          </Route>
          <Route exact path={ROUTES.WOO_CONNECT}>
            <StoreConnector.Form store="WOOCOMMERCE" onCancel={onBackToRoot} />
          </Route>
          <Route exact path={ROUTES.BIGCOMMERCE}>
            <StoreConnector.Form store="BIGCOMMERCE" onCancel={onBackToRoot} />
          </Route>
          <Route exact path={ROUTES.ROOT}>
            <StoreConnector.Card title="Select your platform">
              <StoreConnector.Tiles onClick={onTileClick} />
            </StoreConnector.Card>
          </Route>
          <Redirect to={ROUTES.LOGIN} />
        </Switch>
      </div>
    </UiKit.Grid>
  );
}

export { ConnectStore };
